/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connect_Account_IdInputs */

const en_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Account ID`)
};

const es_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de cuenta Connect`)
};

const fr_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de compte Connect`)
};

const de_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect-Konto-ID`)
};

const ja_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect アカウント ID`)
};

const zh_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect 账户 ID`)
};

const ar_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرف حساب Connect`)
};

const id_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Akun Connect`)
};

const it_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Account Connect`)
};

const ru_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID аккаунта Connect`)
};

const pt_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da Conta Connect`)
};

const ko_connect_account_id = /** @type {(inputs: Connect_Account_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect 계정 ID`)
};

/**
* | output |
* | --- |
* | "Connect Account ID" |
*
* @param {Connect_Account_IdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const connect_account_id = /** @type {((inputs?: Connect_Account_IdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connect_Account_IdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connect_account_id(inputs)
	if (locale === "es") return es_connect_account_id(inputs)
	if (locale === "fr") return fr_connect_account_id(inputs)
	if (locale === "de") return de_connect_account_id(inputs)
	if (locale === "ja") return ja_connect_account_id(inputs)
	if (locale === "zh") return zh_connect_account_id(inputs)
	if (locale === "ar") return ar_connect_account_id(inputs)
	if (locale === "id") return id_connect_account_id(inputs)
	if (locale === "it") return it_connect_account_id(inputs)
	if (locale === "ru") return ru_connect_account_id(inputs)
	if (locale === "pt") return pt_connect_account_id(inputs)
	return ko_connect_account_id(inputs)
});